import { ref } from 'vue'

import OpenGameSound from '../sounds/open-game-sound.mp3'

/** Short sound played when the user starts the game from the init screen. */
export function useStartGameSound() {
    const startGameAudio = ref<HTMLAudioElement | null>(null)

    function loadStartGameSound() {
        const audio = new Audio(OpenGameSound)
        audio.volume = 0.05
        audio.load()

        audio.addEventListener(
            'ended',
            () => {
                startGameAudio.value = null
            },
            { once: true },
        )

        startGameAudio.value = audio
    }

    function playStartGameSound() {
        startGameAudio.value?.play().catch((error) => {
            startGameAudio.value = null
            console.error('Failed to play sound:', error)
        })
    }

    return { loadStartGameSound, playStartGameSound }
}
